import { render, staticRenderFns } from "./ConfigurationTable.vue?vue&type=template&id=fa308734&scoped=true&"
import script from "./ConfigurationTable.vue?vue&type=script&lang=js&"
export * from "./ConfigurationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa308734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa308734')) {
      api.createRecord('fa308734', component.options)
    } else {
      api.reload('fa308734', component.options)
    }
    module.hot.accept("./ConfigurationTable.vue?vue&type=template&id=fa308734&scoped=true&", function () {
      api.rerender('fa308734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product/components/ConfigurationTable.vue"
export default component.exports